import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const StarGlyph = /*#__PURE__*/createElement("g", {
  id: "star",
  width: "18",
  height: "17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    transform: 'scale(4)'
  }
}, /*#__PURE__*/createElement("path", {
  d: "M11.8103 5.62L16.6503 6.04C17.5303 6.11 17.8803 7.21 17.2103 7.79L13.5403 10.97L14.6403 15.7C14.8403 16.56 13.9103 17.24 13.1503 16.78L9.00032 14.27L4.85032 16.77C4.09032 17.23 3.16032 16.55 3.36032 15.69L4.46032 10.97L0.790317 7.79C0.120317 7.21 0.480317 6.11 1.36032 6.04L6.19032 5.63L8.08032 1.17C8.42032 0.36 9.58032 0.36 9.92032 1.17L11.8103 5.62Z",
  fill: "none"
}));
const Star = createSvg({
  name: 'star',
  path: StarGlyph
});

export default Star;
export { StarGlyph };
